import { render, staticRenderFns } from "./PrivacyPolicy.html?vue&type=template&id=8d20b272&external"
import script from "./PrivacyPolicy.ts?vue&type=script&lang=ts&external"
export * from "./PrivacyPolicy.ts?vue&type=script&lang=ts&external"
import style0 from "./PrivacyPolicy.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports